import axios from "axios"
const Base_URL = window.location.origin + '/api'

//Get
export const GetData = async (endpoint) => {
    try {
        const response = await axios.get(`${Base_URL}/${endpoint}`);
        return response.data
    }
    catch (error) {
        console.error(`Error en la solicitud GET a ${endpoint}:`, error);
        throw error;
    }
}
//Post
export const postData = async (endpoint, data) => {
    try {
        const response = await axios.post(`${Base_URL}/${endpoint}`, data);
        return response.data
    }
    catch (error) {
        console.error(`Error en la solicitud a ${endpoint}`, error)
    }
}
